var _rect, _rect2, _g, _path, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBitgetBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 336,
    height: 85,
    viewBox: "0 0 336 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 336,
    height: 85,
    rx: 8,
    fill: "#00F0FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4352_1411",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 336,
    height: 85
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 336,
    height: 85,
    rx: 8,
    fill: "#00F0FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4352_1411)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: -24,
    width: 50,
    height: 40,
    fill: "url(#pattern0_4352_1411)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 15,
    width: 50,
    height: 40,
    fill: "url(#pattern1_4352_1411)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 54,
    width: 50,
    height: 40,
    fill: "url(#pattern2_4352_1411)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: -24,
    width: 50,
    height: 40,
    fill: "url(#pattern3_4352_1411)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 15,
    width: 50,
    height: 40,
    fill: "url(#pattern4_4352_1411)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 54,
    width: 50,
    height: 40,
    fill: "url(#pattern5_4352_1411)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: -24,
    width: 50,
    height: 40,
    fill: "url(#pattern6_4352_1411)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 15,
    width: 50,
    height: 40,
    fill: "url(#pattern7_4352_1411)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 54,
    width: 50,
    height: 40,
    fill: "url(#pattern8_4352_1411)"
  }), /*#__PURE__*/React.createElement("rect", {
    y: -4,
    width: 50,
    height: 40,
    fill: "url(#pattern9_4352_1411)"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 35,
    width: 50,
    height: 40,
    fill: "url(#pattern10_4352_1411)"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 74,
    width: 50,
    height: 40,
    fill: "url(#pattern11_4352_1411)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: -4,
    width: 50,
    height: 40,
    fill: "url(#pattern12_4352_1411)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 35,
    width: 50,
    height: 40,
    fill: "url(#pattern13_4352_1411)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 74,
    width: 50,
    height: 40,
    fill: "url(#pattern14_4352_1411)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: -4,
    width: 50,
    height: 40,
    fill: "url(#pattern15_4352_1411)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 35,
    width: 50,
    height: 40,
    fill: "url(#pattern16_4352_1411)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 74,
    width: 50,
    height: 40,
    fill: "url(#pattern17_4352_1411)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: -4,
    width: 50,
    height: 40,
    fill: "url(#pattern18_4352_1411)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 35,
    width: 50,
    height: 40,
    fill: "url(#pattern19_4352_1411)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 74,
    width: 50,
    height: 40,
    fill: "url(#pattern20_4352_1411)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4352_1411)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4352_1411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 90,
    y: 18,
    width: 156,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M245.955 18H90.0088V65.0324H245.955V18Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4352_1411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.133 40.8215C152.306 40.1552 153.246 39.3257 153.93 38.3478C154.71 37.234 155.106 35.9621 155.106 34.5692C155.106 31.9616 154.131 29.9262 152.21 28.5186C150.312 27.1274 147.7 26.4229 144.445 26.4229H132.674V56.6285H144.915C148.343 56.6285 151.088 55.8317 153.073 54.2584C155.073 52.672 156.089 50.4506 156.089 47.6543C156.089 45.952 155.611 44.4873 154.671 43.3019C153.826 42.2422 152.639 41.4086 151.134 40.8215H151.133ZM139.044 31.8669H143.933C145.466 31.8669 146.624 32.164 147.376 32.7486C148.119 33.3258 148.48 34.0842 148.48 35.0664C148.48 36.0487 148.119 36.8455 147.376 37.4252C146.624 38.0097 145.466 38.3069 143.933 38.3069H139.044V31.8669ZM148.248 50.1607C147.4 50.8399 146.106 51.1837 144.402 51.1837H139.044V43.7918H144.402C146.105 43.7918 147.401 44.124 148.252 44.7763C149.095 45.427 149.505 46.2859 149.505 47.4052C149.505 48.5825 149.094 49.4839 148.248 50.1615V50.1607Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.692 34.041H158.28V56.627H164.692V34.041Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.027 37.4389C227.012 36.2307 225.74 35.2836 224.246 34.6231C222.753 33.9634 221.074 33.627 219.259 33.627C217.033 33.627 215.026 34.1324 213.29 35.1284C211.55 36.1277 210.169 37.5157 209.185 39.2564C208.2 40.9953 207.701 43.0136 207.701 45.2531C207.701 47.4925 208.185 49.6438 209.14 51.4099C210.097 53.1815 211.472 54.571 213.228 55.5434C214.98 56.5101 217.038 57.0007 219.344 57.0007C222.176 57.0007 224.579 56.2888 226.49 54.8837C228.33 53.5318 229.596 51.6245 230.284 49.2372H223.829C223.489 50.0496 223.011 50.7411 222.326 51.2286C221.516 51.8033 220.47 52.0948 219.216 52.0948C218.129 52.0948 217.197 51.8303 216.447 51.3094C215.693 50.7885 215.118 50.0186 214.74 49.0185C214.513 48.4241 214.352 47.7408 214.257 46.9806H230.397L230.429 46.7798C230.717 44.9584 230.645 43.2324 230.21 41.6501C229.775 40.0638 229.04 38.6473 228.027 37.4389ZM214.359 42.7988C214.458 42.3392 214.591 41.8608 214.76 41.4248C215.154 40.4117 215.722 39.6319 216.45 39.111C217.175 38.5901 218.077 38.3272 219.132 38.3272C220.454 38.3272 221.539 38.7558 222.357 39.5993C223.133 40.4018 223.573 41.4983 223.667 42.7988H214.36H214.359Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.826 26.4229H158.146V31.8668H164.826V26.4229Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.941 36.6045C199.183 35.6934 198.294 34.9872 197.291 34.499C196.094 33.9201 194.694 33.627 193.129 33.627C191.213 33.627 189.495 34.0997 188.025 35.0304C186.557 35.9604 185.393 37.2748 184.566 38.9346C183.742 40.5904 183.323 42.5343 183.323 44.715C183.323 46.8957 183.763 48.7253 184.632 50.3925C185.502 52.0654 186.709 53.3978 188.218 54.3547C189.73 55.314 191.454 55.8006 193.343 55.8006C194.77 55.8006 196.073 55.492 197.214 54.8821C198.118 54.3996 198.875 53.7611 199.472 52.9815V55.4406C199.472 56.9649 199.071 58.1348 198.283 58.9145C197.493 59.6941 196.291 60.0878 194.71 60.0878C193.348 60.0878 192.277 59.779 191.528 59.1693C190.914 58.6704 190.379 58.0156 190.254 56.6292H184.072C184.129 58.5692 184.699 59.8762 185.503 61.0217C186.405 62.3051 187.674 63.3085 189.278 64.0017C190.866 64.6867 192.708 65.0345 194.753 65.0345C198.187 65.0345 200.92 64.1715 202.875 62.4716C204.843 60.7621 205.841 58.3683 205.841 55.3581V34.0418H199.941V36.6045ZM198.812 47.7155C198.405 48.5547 197.831 49.2127 197.104 49.6683C196.377 50.1238 195.5 50.3557 194.496 50.3557C193.045 50.3557 191.916 49.8619 191.044 48.8445C190.176 47.8329 189.736 46.4434 189.736 44.7142C189.736 42.985 190.176 41.5954 191.044 40.5823C191.905 39.5789 193.067 39.071 194.496 39.071C195.926 39.071 197.189 39.5861 198.077 40.6051C198.974 41.6322 199.428 43.0291 199.428 44.7542C199.428 45.8719 199.221 46.8671 198.812 47.7147V47.7155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.955 39.4441V34.0426H241.327V26.4229H234.957V34.0426H231.004V39.4441H234.957V48.2862C234.957 53.2019 235.925 56.8147 241.961 56.7028L245.75 56.6285V51.5641H243.87C241.187 51.5641 241.336 49.9999 241.336 47.095L241.326 39.4441H245.955Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.766 39.4441V34.0426H177.138V26.4229H170.768V34.0426H166.814V39.4441H170.768V48.2862C170.768 53.2019 171.736 56.8147 177.772 56.7028L181.561 56.6285V51.5641H179.681C176.998 51.5641 177.147 49.9999 177.147 47.095L177.137 39.4441H181.765H181.766Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.996 31.8661H115.614L125.454 41.6429C126.094 42.2788 126.097 43.3133 125.46 43.9526L112.841 56.6351H102.933L105.929 53.7229L116.927 42.7941L106.068 31.8652",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.949 42.7698H100.33L90.4904 32.9931C89.8503 32.3571 89.8471 31.3226 90.4839 30.6833L103.103 18H113.011L110.015 20.9122L99.0173 31.8411L109.876 42.7698",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_4352_1411",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4352_1411",
    transform: "matrix(0.00238095 0 0 0.00297619 0 -0.00892857)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_4352_1411",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4352_1411",
    transform: "matrix(0.00238095 0 0 0.00297619 0 -0.00892857)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2_4352_1411",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4352_1411",
    transform: "matrix(0.00238095 0 0 0.00297619 0 -0.00892857)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern3_4352_1411",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4352_1411",
    transform: "matrix(0.00238095 0 0 0.00297619 0 -0.00892857)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern4_4352_1411",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4352_1411",
    transform: "matrix(0.00238095 0 0 0.00297619 0 -0.00892857)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern5_4352_1411",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4352_1411",
    transform: "matrix(0.00238095 0 0 0.00297619 0 -0.00892857)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern6_4352_1411",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4352_1411",
    transform: "matrix(0.00238095 0 0 0.00297619 0 -0.00892857)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern7_4352_1411",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4352_1411",
    transform: "matrix(0.00238095 0 0 0.00297619 0 -0.00892857)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern8_4352_1411",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4352_1411",
    transform: "matrix(0.00238095 0 0 0.00297619 0 -0.00892857)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern9_4352_1411",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4352_1411",
    transform: "matrix(0.00238095 0 0 0.00297619 0 -0.00892857)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern10_4352_1411",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4352_1411",
    transform: "matrix(0.00238095 0 0 0.00297619 0 -0.00892857)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern11_4352_1411",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4352_1411",
    transform: "matrix(0.00238095 0 0 0.00297619 0 -0.00892857)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern12_4352_1411",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4352_1411",
    transform: "matrix(0.00238095 0 0 0.00297619 0 -0.00892857)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern13_4352_1411",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4352_1411",
    transform: "matrix(0.00238095 0 0 0.00297619 0 -0.00892857)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern14_4352_1411",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4352_1411",
    transform: "matrix(0.00238095 0 0 0.00297619 0 -0.00892857)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern15_4352_1411",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4352_1411",
    transform: "matrix(0.00238095 0 0 0.00297619 0 -0.00892857)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern16_4352_1411",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4352_1411",
    transform: "matrix(0.00238095 0 0 0.00297619 0 -0.00892857)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern17_4352_1411",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4352_1411",
    transform: "matrix(0.00238095 0 0 0.00297619 0 -0.00892857)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern18_4352_1411",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4352_1411",
    transform: "matrix(0.00238095 0 0 0.00297619 0 -0.00892857)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern19_4352_1411",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4352_1411",
    transform: "matrix(0.00238095 0 0 0.00297619 0 -0.00892857)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern20_4352_1411",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4352_1411",
    transform: "matrix(0.00238095 0 0 0.00297619 0 -0.00892857)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4352_1411"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 156,
    height: 47.0324,
    fill: "white",
    transform: "translate(90 18)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_4352_1411",
    width: 420,
    height: 342,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitgetBanner);
export default __webpack_public_path__ + "static/media/bitgetBanner.bb915b718aebbea424979c23f2f4fb48.svg";
export { ForwardRef as ReactComponent };